import React from "react";
import { checkBoxData } from "../../constants/ConstantsVariable";
import checkImg from "../../images/Checkmark.svg";
const CheckListCompNew = () => {
   return (
      <ul>
         {checkBoxData.map((item) => (
            <li key={item.id} className={`pg-checkbox-container-new-ui ${item?.id === 4 && "mb-0"}`}>
               <img src={checkImg} alt="Check Icon" className="pg-checkbox-style" />
               <span className="pg-commen-para-text-new-ui">{item.text}</span>
            </li>
         ))}
      </ul>
   );
};

export default CheckListCompNew;
